/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  arrayOf, params, shape, string, useDataModel, extend
} from '@thd-nucleus/data-sources';
import { Typography } from '@one-thd/sui-atomic-components';
import { AddToContext } from '../../AddToContext';

export const AddToProductDetails = ({ products }) => {
  const {
    storeId,
    selectedProductDetails
  } = useContext(AddToContext);

  const itemid = products?.length > 0 ? products[0]?.itemId : selectedProductDetails?.itemId;

  const { data } = useDataModel('product', {
    variables: {
      itemId: itemid,
      storeId
    },
    skip: products?.length > 1 || !itemid
  });

  // Note: non-shared qc items do not have itemid
  if (!itemid) {
    return null;
  }

  const { product } = data || {};

  const brandName = product?.identifiers?.brandName || product?.identifiers?.brandName;
  const productLabel = product?.identifiers?.productLabel || product?.identifiers?.productLabel;

  const image = product?.media?.images?.find(
    (img) => img.type === 'IMAGE' && img.subType === 'PRIMARY'
  );

  return (
    <div className="sui-flex">
      {products?.length === 1 && image && (
        <img
          src={image?.url.replace('<SIZE>', '145')}
          alt={productLabel}
          className="sui-aspect-square sui-max-w-[20%] sm:sui-max-w-[30%]"
          width={90}
          height={90}
        />
      )}
      <div className="sui-pl-6">
        {product && (
          <Typography variant="h5" lineClamp="2">
            {brandName}&nbsp;<Typography component="span">{productLabel}</Typography>
          </Typography>
        )}
        {products?.length === 1 && products[0]?.quantity > 1 && (
          <div className="sui-mt-2">
            <Typography weight="bold" variant="body-base">
              Quantity: {products[0].quantity}
            </Typography>
          </div>
        )}
        {products?.length > 1 && (
          <div className="sui-mt-2">
            <Typography weight="bold" variant="body-base">
              {products.length} items selected
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

AddToProductDetails.dataModel = extend({
  product: params({
    itemId: string().isRequired()
  }).shape({
    identifiers: shape({
      brandName: string(),
      productLabel: string(),
      storeSkuNumber: string()
    }),
    media: shape({
      images: arrayOf(shape({
        url: string(),
        type: string(),
        subType: string()
      }))
    })
  })
});

AddToProductDetails.displayName = 'AddToProductDetails';

AddToProductDetails.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({
    itemId: PropTypes.string,
    quantity: PropTypes.number
  }))
};

AddToProductDetails.defaultProps = {
  products: []
};
